<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m20.2 8.6-7.7 5.2q-.5.3-1 0L3.8 8.6V17a1 1 0 0 0 1.1 1.1h14.2a1 1 0 0 0 1.1-1.1zM5 5.8a1 1 0 0 0-1 .7l8.1 5.4 8.1-5.4a1 1 0 0 0-1-.7zM22 17a3 3 0 0 1-3 2.9H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3z"
    />
  </svg>
</template>
